/* eslint-disable camelcase */
import { AvailabilityGroup } from './components/Row';

export const availabilityMockData: AvailabilityGroup[] = [
	{
		id: '93517846-a960-47fd-8604-632cae5bcfdd',
		atc_code: 'L04AB01',
		active_substance: 'etanercept',
		rs: '70/2',
		products: [
			{
				productVersions: [{ suklCode: '209127', brand: 'BENEPALI', description: '50MG INJ SOL ISP 4X0,98ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 21857.12,
					ddd_share: 0.0558,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '209128', brand: 'BENEPALI', description: '50MG INJ SOL PEP 4X0,98ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 134571.29,
					ddd_share: 0.3436,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '26515', brand: 'ENBREL', description: '25MG INJ PSO LQF 4+4X1ML ISP+4J+4AD' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 3771.42,
					ddd_share: 0.0096,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '27905', brand: 'ENBREL', description: '50MG INJ SOL ISP 4X1ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 55599.94,
					ddd_share: 0.142,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '27907', brand: 'ENBREL', description: '25MG INJ SOL ISP 4X0,5ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 1471.43,
					ddd_share: 0.0038,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '149395', brand: 'ENBREL', description: '50MG INJ SOL PEP 4X1ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 101257.04,
					ddd_share: 0.2585,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222378', brand: 'ENBREL', description: '25MG INJ SOL PEP 4X0,5ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 3071.43,
					ddd_share: 0.0078,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [
					{
						suklCode: '154909',
						brand: 'ENBREL PRO PEDIATRICKÉ POUŽITÍ',
						description: '10MG INJ PSO LQF 4+4X1ML ISP+4J+4AD',
					},
				],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 382.86,
					ddd_share: 0.001,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222248', brand: 'ERELZI', description: '50MG INJ SOL ISP 4X1ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 7285.71,
					ddd_share: 0.0186,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222252', brand: 'ERELZI', description: '50MG INJ SOL PEP 4X1ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 50999.95,
					ddd_share: 0.1302,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '249547', brand: 'NEPEXTO', description: '50MG INJ SOL ISP 4X1ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 1142.86,
					ddd_share: 0.0029,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '249549', brand: 'NEPEXTO', description: '50MG INJ SOL PEP 4X1ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 10228.56,
					ddd_share: 0.0261,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
		],
	},
	{
		id: '57313fa9-d986-4dfd-9df5-035ae05d85ca',
		atc_code: 'L04AB02',
		active_substance: 'infliximab',
		rs: '70/2',
		products: [
			{
				productVersions: [{ suklCode: '209370', brand: 'FLIXABI', description: '100MG INF PLV CSL 1' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 111173.47,
					ddd_share: 0.0604,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '27283', brand: 'REMICADE', description: '100MG INF PLV CSL 1' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 66266.75,
					ddd_share: 0.036,
					odtd: null,
					odtd_share: null,
					dnc_dou: false,
				},
			},
			{
				productVersions: [{ suklCode: '194345', brand: 'REMSIMA', description: '100MG INF PLV CSL 1' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 464960.58,
					ddd_share: 0.2524,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '238692', brand: 'REMSIMA', description: '120MG INJ SOL ISP 2X1ML II' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 30272.0,
					ddd_share: 0.0164,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '238695', brand: 'REMSIMA', description: '120MG INJ SOL PEP 2X1ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 838720.0,
					ddd_share: 0.4553,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222969', brand: 'ZESSLY', description: '100MG INF PLV CSL 1' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 330587.08,
					ddd_share: 0.1795,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
		],
	},
	{
		id: '3b94bc60-9774-44d4-85c4-cbfd371a6efd',
		atc_code: 'L04AB04',
		active_substance: 'adalimumab',
		rs: '70/2',
		products: [
			{
				productVersions: [{ suklCode: '238197', brand: 'HULIO', description: '40MG INJ SOL PEP 2X0,8ML III' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 113075.83,
					ddd_share: 0.0717,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '238198', brand: 'HULIO', description: '40MG INJ SOL PEP 6X0,8ML III' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 248.28,
					ddd_share: 0.0002,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '209097', brand: 'HUMIRA', description: '40MG INJ SOL PEP 2X0,4ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 160551.68,
					ddd_share: 0.1017,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '210935', brand: 'HUMIRA', description: '40MG INJ SOL ISP 2X0,4ML I' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 136055.14,
					ddd_share: 0.0862,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222100', brand: 'HUMIRA', description: '80MG INJ SOL ISP 1X0,8ML I' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 35365.51,
					ddd_share: 0.0224,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222377', brand: 'HUMIRA', description: '80MG INJ SOL PEP 1X0,8ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 23862.06,
					ddd_share: 0.0151,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271641', brand: 'HYRIMOZ', description: '80MG INJ SOL ISP 1X0,8ML ISP' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 3834.48,
					ddd_share: 0.0024,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271643', brand: 'HYRIMOZ', description: '80MG INJ SOL PEP 1X0,8ML PEP' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 21875.86,
					ddd_share: 0.0139,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271646', brand: 'HYRIMOZ', description: '40MG INJ SOL ISP 2X0,4ML ISP' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 61903.43,
					ddd_share: 0.0392,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271649', brand: 'HYRIMOZ', description: '40MG INJ SOL PEP 2X0,4ML PEP' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 314124.06,
					ddd_share: 0.1991,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '238432', brand: 'IDACIO', description: '40MG INJ SOL PEP 2X0,8ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 20055.17,
					ddd_share: 0.0127,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271654', brand: 'IMRALDI', description: '40MG INJ SOL ISP 2X(1X0,4ML)' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 4496.55,
					ddd_share: 0.0028,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '271658', brand: 'IMRALDI', description: '40MG INJ SOL PEP 2X(1X0,4ML)' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 137737.9,
					ddd_share: 0.0873,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '21614', brand: 'YUFLYMA', description: '40MG INJ SOL ISP 2X0,4ML II' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 61627.57,
					ddd_share: 0.0391,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '22097', brand: 'YUFLYMA', description: '40MG INJ SOL PEP 2X0,4ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 426179.2,
					ddd_share: 0.2701,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '255518', brand: 'YUFLYMA', description: '80MG INJ SOL ISP 1X0,8ML II' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 4551.72,
					ddd_share: 0.0029,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '255519', brand: 'YUFLYMA', description: '80MG INJ SOL PEP 1X0,8ML' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 52386.19,
					ddd_share: 0.0332,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
		],
	},
	{
		id: '787eb1cc-153b-472d-b9da-f05fefb4d0cb',
		atc_code: 'L04AB04',
		active_substance: 'adalimumab',
		rs: null,
		products: [
			{
				productVersions: [{ suklCode: '209099', brand: 'HUMIRA', description: '40MG INJ SOL PEP 6X0,4ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 18289.65,
					ddd_share: 0.6326,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '222669', brand: 'HUMIRA', description: '20MG INJ SOL ISP 2X0,2ML I' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 6441.38,
					ddd_share: 0.2228,
					odtd: null,
					odtd_share: null,
					dnc_dou: false,
				},
			},
			{
				productVersions: [{ suklCode: '271652', brand: 'HYRIMOZ', description: '20MG INJ SOL ISP 2(2X1)X0,2ML ISP' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 3558.62,
					ddd_share: 0.1231,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '272073', brand: 'YUFLYMA', description: '20MG INJ SOL ISP 2X0,2ML I' }],
				availability: {
					status: 'not-available',
					reasonCode: 'under-5-percentage',
					ddd: 620.69,
					ddd_share: 0.0215,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
		],
	},
	{
		id: '97aa4860-20fd-4f4e-a353-66614707549f',
		atc_code: 'L04AB05',
		active_substance: 'certolizumab pegol',
		rs: '70/2',
		products: [
			{
				productVersions: [{ suklCode: '149645', brand: 'CIMZIA', description: '200MG INJ SOL ISP 2X1ML I' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 57885.66,
					ddd_share: 0.35,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
			{
				productVersions: [{ suklCode: '219340', brand: 'CIMZIA', description: '200MG INJ SOL PEP 2X1ML AUTOCLICKS' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 107485.61,
					ddd_share: 0.65,
					odtd: null,
					odtd_share: null,
					dnc_dou: true,
				},
			},
		],
	},
	{
		id: '0b43b068-74a7-4f15-a2a1-5df8cafd2abe',
		atc_code: 'L04AB06',
		active_substance: 'golimumab',
		rs: '70/2',
		products: [
			{
				productVersions: [{ suklCode: '149564', brand: 'SIMPONI', description: '50MG INJ SOL PEP 1X0,5ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 118735.01,
					ddd_share: 0.8412,
					odtd: null,
					odtd_share: null,
					dnc_dou: false,
				},
			},
			{
				productVersions: [{ suklCode: '149566', brand: 'SIMPONI', description: '50MG INJ SOL ISP 1X0,5ML' }],
				availability: {
					status: 'available',
					reasonCode: 'has-over-5-percentage',
					ddd: 22409.65,
					ddd_share: 0.1588,
					odtd: null,
					odtd_share: null,
					dnc_dou: false,
				},
			},
		],
	},
];
